import { GetTotalPass } from "../../reducers/totalPass";

export interface TotalPassDetalleStore extends GetTotalPass {}

export const totalPassDetalleStore: (
  state
) => TotalPassDetalleStore = state => {
  const { totalPass } = state;
  return {
    totalPass: totalPass.totalPass,
    gettingTotalPass: totalPass.gettingTotalPass,
    gettingTotalPassError: totalPass.gettingTotalPassError
  };
};
